import { Link } from "react-router-dom";

export default function Login(){
  return(
    <div>
      Login sequence coming soon! 
      <br/> For now, <Link to="/app">click here</Link>. 
    </div>
  );
}